import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Summer2019 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='Summer2019'>
			<div className="promoBanner">
				<img className='desktop600' src="/img/promopages/summer2019/banner.jpg" alt="Diamonds Direct Summer" />
				<img className='mobile600' src="/img/promopages/summer2019/banner_mobile.jpg" alt="Diamonds Direct Summer" />
			</div>
			<div className="promoBody">
				<div className="promoBodyInner">
					<div className="promoText">
						 Internationally renowned designers have curated exclusive collections for each of our stores. Visit our stores during our Summer Design Showcase to learn more!
					</div>
					<div className="springLocationBlock">
						<div className={"springLocationItem"}>
							<div className="springDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2019/july12-14.svg' />
							</div>
							<div className={"springLocations"}>
								<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
								<br />
								<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/salt-lake-city">Salt&nbsp;Lake&nbsp;City,&nbsp;UT</a>
							</div>
						</div>
						<div className="springLocationItem">
							<div className="springDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2019/july19-21.svg' />
							</div>
							<div className="springLocations">
								<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/cleveland">Cleveland,&nbsp;OH</a>
								<br />
								<a className="holiday-location-link" href="/kansas-city">Kansas&nbsp;City,&nbsp;KS</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
							</div>
						</div>
						<div className="springLocationItem">
							<div className="springDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2019/july26-28.svg' />
							</div>
							<div className="springLocations">
								<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
								<br />
								<a className="holiday-location-link" href="/san-antonio">San&nbsp;Antonio,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>
							</div>
						</div>
						<div className="springLocationItem">
							<div className="springDates">
								<img src='https://ddw2.diamondsdirect.com/img/promopages/summer2019/aug2-4.svg' />
							</div>
							<div className="springLocations">
								<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/columbus">Columbus,&nbsp;OH</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
								<br />
								<a className="holiday-location-link" href="/frisco">Frisco,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/jacksonville">Jacksonville,&nbsp;FL</a>
							</div>
						</div>
					</div>
					<div className='promoLegal'>
						*Discount excludes certified diamonds and price protected lines.<br />Cannot be combined with other offers.
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Summer2019;

function mapStateToProps(state) {
  return {

  };
}

export const Summer2019Container = connect(
  mapStateToProps,
  allActionCreators
)(Summer2019);


// WEBPACK FOOTER //
// ./src/components/views/promopages/summer2019/Summer2019.jsx